import React from 'react';
import { Common } from '@stockbit/ui';
import { DropdContainer } from './styled';
import Image from 'global/Image';

const { Text, IconWrapper, Iconmoon } = Common;

interface NavigationDropdownProps {
  children: React.ReactNode;
  [key: string]: any;
}

function NavigationDropdown({
  children = <div />,
  ...otherProps
}: NavigationDropdownProps) {
  return (
    <DropdContainer {...otherProps}>
      <Text as="button">{children}</Text>
      <IconWrapper padding="0 5px">
        <Image src="/icon/widget-trending/arrow-down.svg" />
      </IconWrapper>
    </DropdContainer>
  );
}

export default NavigationDropdown;
